var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay_vcode"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vcode_card"
  }, [_c('div', {
    staticClass: "vcode_phone"
  }, [_vm._v("请验证手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "vcode_pass"
  }, [_vm._v("我们将在此手机号绑定的微信上为您开通服务")]), _vm._v(" "), _c('div', {
    staticClass: "vcode_bg"
  }, [_c('div', {
    staticClass: "group border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.order.customer_mobile),
      expression: "order.customer_mobile",
      modifiers: {
        "trim": true
      }
    }],
    ref: "txtPhone",
    staticStyle: {
      "ime-mode": "disabled"
    },
    attrs: {
      "type": "tel",
      "placeholder": "手机号码",
      "maxlength": "11",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.order.customer_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.customer_mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.sms_code),
      expression: "sms_code",
      modifiers: {
        "trim": true
      }
    }],
    ref: "txtSmsCode",
    staticClass: "vcode-cont",
    attrs: {
      "type": "tel",
      "name": "verification_code",
      "id": "verification_code",
      "placeholder": "验证码",
      "maxlength": "6",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.sms_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sms_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    ref: "btnSend",
    class: _vm.sending_class,
    attrs: {
      "id": "get_verification_code",
      "disabled": _vm.sending_code
    },
    on: {
      "click": function($event) {
        _vm.getCode('SMS')
      }
    }
  }, [_vm._v(_vm._s(_vm.sending_text))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "voices"
  }, [_vm._v("\n      收不到短信验证码？使用\n      "), _c('span', {
    class: _vm.vms_color,
    on: {
      "click": function($event) {
        _vm.getCode('VMS')
      }
    }
  }, [_vm._v("语音验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "actions mt-50"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSmsCode
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay_success"
  }, [_c('img', {
    staticClass: "pay_icon",
    attrs: {
      "src": "/static/img/payicon.png"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "yellow"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('p', [_vm._v("1、请谨慎使用验证码，超限将无法接收到短信信息")]), _vm._v(" "), _c('p', [_vm._v("2、短信验证是为了后续能顺利进行问卷填写、合同签订，服务开通等步骤。")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-3d7e3218","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/sms/MobileVerify.vue
// module id = 230
// module chunks = 0